import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import StrategizeView from "../views/StrategizeView.vue";
import DecisionDeskView from "../views/DecisionDeskView.vue";
import CommandCenterView from "../views/CommandCenterView.vue";
import HomeView from "../views/HomeView.vue";
import { clearSession, getCurrentUser, getSession } from "../auth.js";

const routes = [
    {
        path: `/`,
        name: "login",
        component: LoginView,
        meta: { hideNavbar: true },
    },

    {
        path: `/home`,
        name: "home",
        component: HomeView,
        props: true,
        meta: { requiresAuth: true },
    },

    {
        path: `/opportunity-hub`,
        name: "opportunity-hub",
        component: StrategizeView,
        props: true,
        meta: { requiresAuth: true },
    },

    {
        path: `/agent-studio`,
        name: "agent-studio",
        component: DecisionDeskView,
        props: true,
        meta: { requiresAuth: true },
    },

    {
        path: `/impact-center`,
        name: "impact-center",
        component: CommandCenterView,
        props: true,
        meta: { requiresAuth: true },
    },

    // Old URLs, kept so existing bookmarks and shared links still land on the right screen.
    { path: `/strategize`, redirect: { name: "opportunity-hub" } },
    { path: `/nba-workbench`, redirect: { name: "agent-studio" } },
    { path: `/command-center`, redirect: { name: "impact-center" } },

    {
        path: "/:catchAll(.*)*",
        name: "NotFound",
        component: NotFoundView,
        meta: { hideNavbar: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    base: `${process.env.VUE_APP_PUBLIC_PATH}`,
    routes,
});

router.beforeEach(async (to) => {
    if (to.meta.requiresAuth) {
        try {
            await getCurrentUser();
            return true;
        } catch {
            clearSession();
            return { name: "login" };
        }
    }

    if (to.name === "login" && getSession()) {
        try {
            await getCurrentUser();
            return { name: "home" };
        } catch {
            clearSession();
        }
    }
    return true;
});

export default router;
